module.exports = __webpack_public_path__ + "static/img/share-img.c4a98a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/share-img.jpg
// module id = GLG8
// module chunks = 1